<template>
	<div class="follow-order">
		<div class="warning">
			<div class="d-flex">
				<img src="../../assets/images/iconPack/carbon_warning-square.svg" />
				<span class="text">توجه</span>
			</div>
			<div>
				<ul>
					<li>تعداد اعلان های هر مشتری، نمایانگر تعداد سوالاتی است که بیش از سه بار متوالی پاسخ نامطلوب
					برایشان ثبت شده است.</li>
					<li>
						با کلیک روی هر اعلان میتوانید مواردی که باعث ایجاد آن شده اند (سوالاتی که ۳مرتبه متوالی پاسخ نامطلوب داشته اند) را مشاهده کنید.
					</li>
				</ul>
			</div>
		</div>
		<div class="box">
			<span class="title">فیلترها</span>

			<div class="row mt-3">
				<div class="col d-flex flex-column">
					<label for="html">استان:</label>
					<select @change="getCityOnChange" v-model="pickProvince" class="form-select">
						<option v-for="province in provinceLists" :value="province.id" :key="province.id">
							{{ province.name }}
						</option>
					</select>
				</div>
				<div class="col d-flex flex-column">
					<label for="html">شهر:</label>
					<select v-model="pickCity" class="form-select">
						<option v-for="city in cityLists" :value="city.city.id" :key="city.city.id">
							{{ city.city.name }}
						</option>
					</select>
				</div>
				<!-- <div class="col">
					<label for="html">نیروی اجرایی:</label>
					<select v-model="pickPromoter" class="form-select">
						<option v-for="promoter in promoterLists" :value="promoter.id" :key="promoter.id">
							{{ promoter.user.first_name }} {{ promoter.user.last_name }}
						</option>
					</select>
				</div> -->

				<div class="col d-flex flex-column">
					<label for="html">تعداد ویزیت:</label>
					<input class="inputs" v-model="visitCount" />
				</div>
				<div class="col d-flex flex-column">
					<label for="html">کد مشتری:</label>
					<input class="inputs" v-model="storeCode" />
				</div>

				<div class="col d-flex flex-row align-items-end w-100">
					<button @click="getDataPackage((limit = 20), (offset = 0))" class="accept">تایید</button>
					<button class="remove-filtes" @click="removeFilter">حذف فیلتر</button>

					<!-- <img class="trash-icon" @click="removeFilter" src="../../assets/images/iconPack/trash-icon.png"> -->
				</div>
			</div>
		</div>
		<div class="box">
			<div class="d-flex justify-content-between">
				<pagination
					v-model="page"
					:per-page="20"
					:records="totalDataCount"
					@paginate="myCallback"
				/>
				<!-- <div class="d-flex flex-row align-items-center">
					<span class="ordering-title">مرتب سازی بر اساس :</span>
					<b-form-select
						v-model="selected"
						:options="options"
						class="ordering"
						value-field="item"
						text-field="name"
						@change="getDataPackage((limit = 10), (offset = 0), (order = selected))"
					></b-form-select>
				</div> -->
			</div>
			<div>
				<Tableview
					:hover="true"
					:bordered="true"
					:showNoContent="showContnetFunc"
					:showNoData="showDataFunc"
				>
					<template #TableTitle>
						<tr>
							<th>ردیف</th>
							<th>شهر</th>
							<th>نام مشتری</th>
							<th>ادرس مشتری</th>
							<th>کد مشتری</th>
							<th>تعداد ویزیت</th>
							<th>اعلان ها</th>
							<th>مشاهده ویزیت ها</th>
						</tr>
					</template>

					<template #TableBody>
						<tr v-for="(item, index) in dataPackage" :key="item.id">
							<td class="persian-number">
								{{ 20 * (page - 1) + 1 + index }}
							</td>
							<td>{{ item.city.name }}</td>
							<td>{{ item.name }}</td>
							<td class="persian-number">{{ item.address }}</td>
							<td class="persian-number">{{ item.code }}</td>
							<td class="persian-number">{{ item.visit_count }}</td>
							<td @click="warningPage(item.id)" v-if="item.foul_alarms_data.count > 0">
							<div class="d-flex justify-content-center">
								<div class="warning-box" v-bind:style="{ backgroundColor: item.foul_alarms_data.color }">
									{{ item.foul_alarms_data.count }}
								</div>
								
							</div>
							</td>
							<td v-else></td>
							<td>
								<img
									@click="detail(item.id)"
									class="eye-icon"
									src="../../assets/images/iconPack/eye.svg"
								/>
							</td>
						</tr>
					</template>
				</Tableview>
			</div>
		</div>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';

export default {
	components: {
		Tableview,
		Pagination,
	},
	data() {
		return {
			dataPackage: 0,
			cityLists: [],
			promoterLists: [],
			provinceLists: [],
			pickProvince: '',
			pickCity: '',
			visitCount: '',
			storeCode: '',
			selectedkCity: '',
			page: 1,
			totalDataCount: 0,
			selected: '-datetime_last_change',
			options: [
				{ item: '-datetime_last_change', name: 'صعودی' },
				{ item: 'datetime_last_change', name: 'نزولی' },
			],
			rangeDate: [],
		};
	},
	mounted() {
		this.getDataPackage();
		this.getCity();
		this.getPromoterLists();
		this.getProvince();
	},
	computed: {
		selectedPromoterId() {
			return this.pickPromoter.id;
		},
		selectedCityId() {
			return this.pickCity.id;
		},
		selectedProvinceId() {
			return this.pickProvince.id;
		},
		showContnetFunc() {
			return this.dataPackage === 0;
		},
		showDataFunc() {
			if (this.dataPackage.length !== undefined) {
				return this.dataPackage.length === 0;
			}
			return false;
		},
	},
	methods: {
		removeFilter() {
			this.pickCity = '';
			this.storeCode = '';
			this.pickProvince = '';
			this.selectedkCity = '';
			this.visitCount = '';
			this.getDataPackage();
			this.getCity();
		},
		getCityOnChange() {
			this.selectedkCity = this.pickProvince;
			this.getCity();
		},
		async getDataPackage(limit = 20, offset = 0) {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_OUTLET_LIST +
					'?category=1' +
					'&city=' +
					this.pickCity +
					'&city__province=' +
					this.pickProvince +
					'&visit_count=' +
					this.visitCount +
					'&code=' +
					this.storeCode +
					'&limit=' +
					limit +
					'&offset=' +
					offset +
					'&ordering=' +
					this.selected + 
					'&p=' + this.$STORE.state.userConfig.setProjectId
					,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.dataPackage = res.data.results;
				('sd:', this.dataPackage);
				this.totalDataCount = res.data.count;
			}
		},
		async myCallback() {
			await this.getDataPackage(20, 20 * (this.page - 1));
		},
		detail(id) {
			let routeData = this.$router.resolve({
				name: 'storeManagementAcceptedvisits',
				params: { outlet: id },
			});
			window.open(routeData.href);
		},
		async getProvince() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.provinceLists = res.data;
			}
		},
		async getCity() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST + '?city__province=' + this.selectedkCity + '&p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				('city:', res.data);
				this.cityLists = res.data;
			}
		},
		async getPromoterLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROMOTER_LIST + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				('promoter:', res.data);
				this.promoterLists = res.data;
			}
		},
		warningPage(id) {
			this.$router.push({name:'warningPage', params: { id: id }})
		},
	},
};
</script>
<style lang="scss" scoped>
.follow-order {
	padding: 32px 50px;
	.warning {
		display: flex;
		flex-direction: column;
		border: 1px solid #ffecb4;
		background: #fff3cd;
		padding: 16px;
		margin-bottom: 32px;
		border-radius: 8px;
		ul {
			margin-bottom: 0 !important;
			padding: 10px 35px;
		}
		li {
			list-style: disc;
		}
		.text {
			color: #664d03;
			font-size: 16px;
			margin-right: 15px;
		}
	}
	.box {
		// border: 1px solid #c4c4c4;
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;
		.title {
			font-weight: 700;
			font-size: 18px;
		}
		.package-number {
			height: 38px;
			text-indent: 10px;
		}
		.inputs {
			width: 100%;
			height: 38px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
			font-family: 'IRANYekanfa' !important;
			border-radius: 8px;
		}
	}
	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}
	.warning-box {
		border-radius: 8px;
		padding: 4px 10px;
		font-family: 'IRANYekanfa' !important;
		color: #fff;
		cursor: pointer;
	}
	.form-select {
		width: 100%;
		border: 1px solid #c4c4c4;
		height: 38px;
		padding: 0 9px;
		border-radius: 8px;
		color: #828282;
		border-radius: 8px;

	}
	.accept {
		height: 38px;
		background: #2d8b8b;
		border-radius: 8px;
		color: #fff;
		border: none !important;
		margin-left: 10px;
		width: 50%;
		border-radius: 8px;
	}
	.remove-filtes {
		width: 50%;
		border: 1px solid #2d8b8b;
		border-radius: 8px;
		color: #2d8b8b;
		height: 38px;
		background: #fff;
		border-radius: 8px;

	}
	.ordering-title {
		min-width: 180px;
	}
	.ordering {
		max-width: 100px;
	}
	.show-date {
		border: none;
		text-indent: 55px;
		background: #fff;
	}

	.eye-icon {
		width: 32px;
		cursor: pointer;
	}
}
</style>

<style>

.VuePagination__count {
	display: none;
}
.page-item.active .page-link {
	background-color: #2d8b8b;
	border-radius: 8px;

}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
